import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Auth token management
let authToken = localStorage.getItem('adminToken');

export const setAuthToken = (token) => {
  authToken = token;
  localStorage.setItem('adminToken', token);
};

export const clearAuthToken = () => {
  authToken = null;
  localStorage.removeItem('adminToken');
};

export const getAuthToken = () => authToken;

// Axios instance with auth
const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (username, password) => 
    axios.post(`${API_URL}/admin/login`, { username, password }),
  
  logout: () => {
    clearAuthToken();
  }
};

// Cars API
export const carsAPI = {
  getAll: (params) => axios.get(`${API_URL}/cars`, { params }),
  getById: (id) => axios.get(`${API_URL}/cars/${id}`),
  getLatestArrival: () => axios.get(`${API_URL}/cars/latest-arrival`),
  create: (data) => apiClient.post(`${API_URL}/admin/cars`, data),
  update: (id, data) => apiClient.put(`${API_URL}/admin/cars/${id}`, data),
  delete: (id) => apiClient.delete(`${API_URL}/admin/cars/${id}`),
};

// Appointments API
export const appointmentsAPI = {
  create: (data) => axios.post(`${API_URL}/appointments`, data),
  getAll: () => apiClient.get(`${API_URL}/admin/appointments`),
  getById: (id) => apiClient.get(`${API_URL}/admin/appointments/${id}`),
  update: (id, data) => apiClient.put(`${API_URL}/admin/appointments/${id}`, data),
};

// Contacts API
export const contactsAPI = {
  create: (data) => axios.post(`${API_URL}/contact`, data),
  getAll: () => apiClient.get(`${API_URL}/admin/contacts`),
  update: (id, data) => apiClient.put(`${API_URL}/admin/contacts/${id}`, data),
};

// Estimation Requests API (Sell-your-car flow)
export const estimationsAPI = {
  create: (data) => axios.post(`${API_URL}/estimation-requests`, data),
  getAll: () => apiClient.get(`${API_URL}/admin/estimation-requests`),
  update: (id, data) => apiClient.put(`${API_URL}/admin/estimation-requests/${id}`, data),
};

// Newsletter API
export const newsletterAPI = {
  subscribe: (data) => axios.post(`${API_URL}/newsletter/subscribe`, data),
};

// Email Contacts API (admin marketing list)
export const emailContactsAPI = {
  getAll: (params) => apiClient.get(`${API_URL}/admin/email-contacts`, { params }),
  remove: (id) => apiClient.delete(`${API_URL}/admin/email-contacts/${id}`),
  csvUrl: (params = {}) => {
    const search = new URLSearchParams(params).toString();
    return `${API_URL}/admin/email-contacts.csv${search ? `?${search}` : ''}`;
  },
};

// Users API
export const usersAPI = {
  getAll: () => apiClient.get(`${API_URL}/admin/users`),
  create: (data) => apiClient.post(`${API_URL}/admin/users`, data),
  delete: (id) => apiClient.delete(`${API_URL}/admin/users/${id}`),
  changePassword: (data) => apiClient.put(`${API_URL}/admin/change-password`, data),
};

// Testimonials API
export const testimonialsAPI = {
  getApproved: () => axios.get(`${API_URL}/testimonials`),
  submit: (data) => axios.post(`${API_URL}/testimonials`, data),
  adminList: (status) => apiClient.get(`${API_URL}/admin/testimonials`, { params: status ? { status } : {} }),
  adminUpdate: (id, data) => apiClient.put(`${API_URL}/admin/testimonials/${id}`, data),
  adminDelete: (id) => apiClient.delete(`${API_URL}/admin/testimonials/${id}`),
};

export default {
  auth: authAPI,
  cars: carsAPI,
  appointments: appointmentsAPI,
  contacts: contactsAPI,
};
